module.exports = __webpack_public_path__ + "static/img/eduplat.995b4711.png";